import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { IRessourceCategory } from '../models/ressource-category';
import { RessourceCategoryService } from '../services/ressource-category.service';

@Component({
    selector: 'app-ressource-category',
    templateUrl: './ressource-category.component.html',
    styleUrls: ['./ressource-category.component.css'],
    standalone: false
})
export class RessourceCategoryComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private RessourceCategoryService : RessourceCategoryService
  ) { }

  ressourceCategorys : IRessourceCategory[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;



  ngOnInit(): void {
    this.ressourceCategorys = this.route.snapshot.data.ressourceCategories as IRessourceCategory[];
  }

  updateList(){
    this.RessourceCategoryService.searchRessourceCategories({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.ressourceCategorys = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      color: new UntypedFormControl(null, Validators.required),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
      color: new UntypedFormControl(dataItem.color, Validators.required),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      color: event.formGroup.value.color,
      id: event.dataItem.id ?? null,
    }
    if (!event.dataItem.id){
      this.RessourceCategoryService.createRessourceCategory(request)
      .subscribe(response => {
        this.updateList();
      });
    } else {
      this.RessourceCategoryService.updateRessourceCategory(request)
      .subscribe(response => {
        this.updateList();
      });;
    }

    event.sender.closeRow(event.rowIndex);
    
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.RessourceCategoryService.deleteRessourceCategory(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

}
